"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export type TupleDeclaration = {
//   type: 'Tuple'
//   length: number
//   declaration: Declaration
// }
// export type TupleDeclarationType<D extends TupleDeclaration> = IsAny<D> extends true
//   ? any
//   : IsNever<D> extends true
//   ? never
//   : Repeat<
//       (D['declaration'] extends never
//         ? never // prevents "circularly references itself" error
//         : {
//             tuple: TupleDeclarationType<Extract<D['declaration'], TupleDeclaration>>
//             others: DeclarationType<Exclude<D['declaration'], TupleDeclaration>>
//           })['tuple' | 'others'],
//       D['length']
//     >
// export type TupleMatchType<D extends TupleDeclaration> = IsAny<D> extends true
//   ? any
//   : IsNever<D> extends true
//   ? never
//   : Repeat<
//       (D['declaration'] extends never
//         ? never // prevents "circularly references itself" error
//         : {
//             tuple: TupleMatchType<Extract<D['declaration'], TupleDeclaration>>
//             others: MatchType<Exclude<D['declaration'], TupleDeclaration>>
//           })['tuple' | 'others'],
//       D['length']
//     >
